export const getDataUriMimeType = (encoded: string) => {
  const mime = encoded?.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
  return mime?.length ? mime[1] : null;
};
